// extracted by mini-css-extract-plugin
module.exports = {"col_box":"col_box-2rsiB1kX","col_navlist":"col_navlist-Bl9PnGi2","pa":"pa-S1l5Uf61"};